import styled from 'styled-components';

export const Sidebar = styled.div`
    width: 34%;
    padding-right: 16px;
    position: relative;

    @media (max-width: 30em) {
        width: 100%;
        padding-right: 0;
    }
`;

export const Title = styled.div`
    font-size: 20px;
    line-height: 28px;
    font-weight: bold;
`;

export const SubTitle = styled.div`
    font-size: 20px;
    line-height: 28px;
    font-weight: normal;
`;

export const NotYourRepInfo = styled.div`
    font-family: Lato;
    font-size: 0.75em;
    line-height: 1.33;
    font-weight: bold;
    margin-top: 5px;
    z-index: 1;

    @media (max-width: 30em) {
        position: absolute;
        right: 0;
        top: 0;
    }
`;

export const Logo = styled.img`
    margin-bottom: 22px;

    @media (max-width: 30em) {
        margin-bottom: 8px;
    }
`;

export const LegalInfoWrapper = styled.div`
    position: absolute;
    bottom: 12px;
    bottom: ${props => (props.showReceiveUpdates ? '0' : 'none')};
    left: 0;
    padding-right: 15px;

    @media (max-width: 30em) {
        padding: 0;
        bottom: -10px;
    }
`;

export const SidebarDescription = styled.p`
    font-size: 0.875em;
    line-height: 1.3;
    color: #333;
    margin: 1em 0;
`;
